import { Checkbox, Space } from '@bfe/moly';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { useEffect, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { doubleConfirmSave } from '@/services/setting';
import { UserInfo } from '@/services/types/common';
import { useStore } from '@/store/useStore';
import { useUserStore } from '@/store/useUser';
import { complianceExtData, complianceHide } from '@/utils/complianceHelpers';
import { $tracing } from '@/utils/tracing';

import TimeZone from './TimeZone';

interface ICheckGroupItem {
  value: string;
  text: string;
  hiddenConfig?: {
    complianceSite: boolean;
  };
}

const getSpecialArr = (sourceArr: CheckboxValueType[]) => {
  const item: Array<any> = [];
  const arr: CheckboxValueType[] = [
    'orderConfirm',
    'hidePhoneConfirm',
    'positionConfirm',
    'obAnimation',
    'cancelAllConfirm',
  ];
  sourceArr.forEach((i) => {
    if (arr.indexOf(i) === -1) item.push(i);
  });
  return item;
};

// const CheckboxGroup = Checkbox.Group;
// 交易组件
const Transaction = () => {
  const [$t] = useI18nContext();
  // const { profile: user, mutate, updateUserProfile } = useUserProfile();
  const { userInfo: user, mutateUserInfo } = useStore();
  const [checkAllGroup, setCheckAllGroup] = useState<string[]>([]);

  const { complianceConfig } = useUserStore();

  useEffect(() => {
    console.log('user =====>', user);
  }, [user]);

  const updateUserByMutate = (obj: UserInfo) => {
    mutateUserInfo((profile: any) => {
      if (profile?.result) profile.result = obj;
      return profile;
    });
  };

  const handleChange = (checkedValues: CheckboxValueType[]) => {
    // const specialArr = getSpecialArr(checkAllGroup);
    // 延迟发送请求

    const tempList = [...checkedValues];
    doubleConfirmSave(tempList).then(() => {
      const confirmObj = {
        ...user,
        double_confirm: tempList.join(),
      } as UserInfo;
      updateUserByMutate(confirmObj);

      $tracing.addEvent({
        t: 'action',
        c: 15109,
        m: `doubleConfirm:${tempList}`,
      });
    });
  };

  useEffect(() => {
    if (user?.double_confirm) {
      //在这里发送请求
      setCheckAllGroup(user?.double_confirm?.split?.(','));
    }
  }, [user]);

  const checkboxGroupArr: ICheckGroupItem[] = [
    { value: 'orderConfirm', text: $t('confirmsDialog.p2') },
    { value: 'hidePhoneConfirm', text: $t('confirmsDialog.p3') },
    {
      value: 'positionConfirm',
      text: $t('confirmsDialog.p4'),
      hiddenConfig: {
        complianceSite:
          complianceExtData(complianceConfig?.TradeConfirmModal)
            ?.positionConfirm === 'hide',
      },
    },
    { value: 'obAnimation', text: $t('confirmsDialog.p5') },
    { value: 'cancelAllConfirm', text: $t('confirmsDialog.p6') },
  ];

  return (
    <div className="transaction-container">
      <h3 className="transaction-setup-title">{$t('Trade')}</h3>
      <div className="transaction-setup-form">
        <div className="transaction-checkbox-group">
          <Space direction="vertical" size={16}>
            <TimeZone />
            {checkboxGroupArr
              .filter(({ hiddenConfig }) => {
                return !hiddenConfig?.complianceSite;
              })
              .map((item: ICheckGroupItem, index: number) => {
                return (
                  <Checkbox
                    key={index}
                    checked={checkAllGroup.includes(item.value)}
                    onChange={(evt, checked) => {
                      let arr = [...checkAllGroup];
                      if (checked) {
                        arr = arr.filter((v: any) => v !== item.value);
                      } else {
                        arr.push(item.value);
                      }
                      handleChange([...arr]);
                      setCheckAllGroup([...arr]);
                    }}
                    className="transaction-setup-form-item-checkbox"
                  >
                    <span className="text-[14px] font-medium">{item.text}</span>
                  </Checkbox>
                );
              })}
          </Space>
        </div>
      </div>
    </div>
  );
};
export default Transaction;
